import { Loader2, TriangleAlert } from 'lucide-react';
import { match } from 'ts-pattern';

import { Alert, AlertTitle } from '@nesso/ui/primitives/alert';

import { useConnectionAlert } from '@/shared/lib/use-connection-alert';

const TOAST_ALERT = '[container-type:normal] w-max max-w-[calc(100vw-2rem)]';

export function ConnectionAlert() {
    const variant = useConnectionAlert();

    return (
        <div className="absolute top-3.25 left-1/2 -translate-x-1/2 z-50">
            {match(variant)
                .with('reconnecting', () => (
                    <Alert className={TOAST_ALERT}>
                        <Loader2 className="size-4 shrink-0 animate-spin" />
                        <AlertTitle className="mb-0 max-xs:line-clamp-2">
                            You lost your internet connection. Trying to reconnect.
                        </AlertTitle>
                    </Alert>
                ))
                .with('unstable', () => (
                    <Alert className={TOAST_ALERT}>
                        <TriangleAlert className="size-4 shrink-0" />
                        <AlertTitle className="mb-0 max-xs:line-clamp-2">
                            Unstable internet connection
                        </AlertTitle>
                    </Alert>
                ))
                .otherwise(() => null)}
        </div>
    );
}
